import { render } from "./AddFactoryModal.vue?vue&type=template&id=7b45b215&scoped=true"
import script from "./AddFactoryModal.vue?vue&type=script&lang=js"
export * from "./AddFactoryModal.vue?vue&type=script&lang=js"

import "./AddFactoryModal.vue?vue&type=style&index=0&id=7b45b215&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b45b215"]])

export default __exports__